class File {

  constructor (el) {
    this.el = el
    this.input = this.el.querySelector('input')
    this.name = this.el.querySelector('.js-file-name')
    this.reset = this.el.querySelector('.js-file-clear')

    this.initDefaults()
  }

  initDefaults () {
    this.initEvents()
  }

  initEvents () {
    this.input.addEventListener('change', e => this.onChange(e))
    this.reset.addEventListener('click', e => this.clear(e))
  }

  clear (e) {
    e.preventDefault()
    this.input.value = ''
    this.el.classList.remove('active')
  }

  onChange (e) {
    this.name.innerHTML = e.target.files[0].name
    this.el.classList.add('active')
  }

}

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.js-file')

  if (items.length) {
    items.forEach(el => {
      new File(el)
    })
  }
})